import api from '../auth';
const slug = 'api/statues/';

const StatusService = () => {
    const getStatuss = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getStatussLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getStatus = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteStatus = (id) => {
        return api
            .delete(slug + `status/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createStatus = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateStatus = (id, data) => {
        return api.put(slug + `status/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyStatus = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getStatuss,
        getStatussLazy,
        getStatus,
        deleteStatus,
        createStatus,
        updateStatus,
        getOptions,
        copyStatus
    };
};

export default StatusService;
